import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../shared/services/payment.service";
import { ActivatedRoute, Router } from "@angular/router";
import { delay, switchMap, takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";

import { encryptRequest } from "src/app/core/constants/constants";
import { AuthService } from "src/app/core/auth/auth.service";
import { StorageService } from "src/app/core/helpers/storage-Service";

@Component({
  selector: "app-recurring-payment",
  templateUrl: "./recurring-payment.component.html",
  styleUrls: ["./recurring-payment.component.scss"],
  standalone: false,
})
export class RecurringPaymentComponent implements OnInit {
  tabIndex: number = 0;
  destroy$ = new Subject();

  clientId: string;
  clientRef: string;

  recurringPayment: any;
  showModal: boolean;

  agreeTerms: boolean;
  subHeader: string;
  isInstalmentPlan = false;

  constructor(
    private payService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.isInstalmentPlan = this.router.url.includes("instalment");
    this.route.params.subscribe((param) => {
      this.clientRef = param.ref;
      this.clientId = param.clientId;
      this.getToken("subscription", this.clientId, this.clientRef)
        .pipe(
          switchMap((res: any) => {
            this.storageService.saveAccessToken(res.token);
            return this.isInstalmentPlan
              ? this.getInstalmentplanPayment(this.clientRef)
              : this.getRecurringPayment(this.clientRef);
          }),
        )
        .subscribe();
    });
  }

  // Return observable, don't subscribe
  getRecurringPayment(reference: string) {
    return this.payService.getRecurringPayment(reference, this.clientId).pipe(
      delay(1000),
      tap((res) => {
        this.recurringPayment = res;
      }),
      takeUntil(this.destroy$),
    );
  }

  // Return observable, don't subscribe
  getInstalmentplanPayment(reference: string) {
    return this.payService.getInstalmentPlan(reference, this.clientId).pipe(
      delay(1000),
      tap((res) => {
        this.recurringPayment = {
          ...res,
          name: res.planName,
          amount: res.amount,
        };
      }),
      takeUntil(this.destroy$),
    );
  }

  handleAccept() {
    this.router.navigate(["client-details", this.clientId], {
      queryParams: {
        q: encryptRequest(this.recurringPayment),
        // only add isInstalment when true
        ...(this.isInstalmentPlan && {
          isInstalment: true,
        }),
      },
    });
  }

  handleDecline() {
    this.showModal = true;
    this.subHeader = `You are about to decline reoccurring payments from ${this.recurringPayment.name}. This action cannot be reversed.`;
  }

  decline() {
    this.router.navigate(["payments/declined"]);
  }

  getToken(entityType: string, clientId: string, ref: string) {
    return this.authService.getAccessControl(entityType, clientId, ref);
  }
}
